import { render, staticRenderFns } from "./CadastroMateriais.vue?vue&type=template&id=04f5741e&"
import script from "./CadastroMateriais.vue?vue&type=script&lang=js&"
export * from "./CadastroMateriais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports